import React, { useEffect, useRef, useState } from "react";
import GenericHeader from "../../components/GenericHeader/GenericHeader";
import "./AddCluster.css";
import DropdownList from "../../components/DropdownList/DropdownList";
import { validatescore } from "../../util/util";
import PopUp from "../../components/PopUp/PopUp";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchAllCountries, fetchByfilter } from "../../services/GenericAPI";
import { setAllCountries, setAllGeners, setAllScriptTypes } from '../SignUp/ProducerRegistrationSlice';
import {useDispatch, useSelector } from "react-redux";
import { createClusterApi, fetchAllScriptTypes, updateClusterApi } from "../../services/api";
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
import { useLanguage } from "../../context/Languagecontext";
import { Globals as OldGlobals } from "../../global/Globals";

const AddCluster = () => {
  const { Globals, languages, setLanguages } = useLanguage();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { activeHeader, update, formValues } = location.state || '';
  const addEditCluster = update ? 'UPDATE_CLUSTER':'ADD_NEW_CLUSTER'; // checking add/edit cluster

  const dropdownRefs = useRef({}); 
  const [name,setName]=useState(update ? formValues?.name : "");
  const [score,setScore]=useState(update ? formValues?.approvalScore : "");
  const [isScoreInvalid, setIsScoreInvalid] = useState(false);
  const [isCountryInvalid, setIsCountryInvalid] = useState(false);
  const [isScriptInvalid, setIsScriptInvalid] = useState(false);
  const [country, setCountry] = useState({});
  const [selectedScriptType, setSelectedScriptType] = useState({});
  const [isGenreUnselected, setIsGenreUnselected] = useState(false);
  const [dropdownState, setDropdownState] = useState({
    activeDropdown: false,
    dropdowns: { selected: [], selectedText: [] },
  });

  const allCountriesData = useSelector(state => state.producerRegistration.allCountries);
  const allScriptTypesData = useSelector(state => state.producerRegistration.allScriptTypes);
  const allGenersData = useSelector(state => state.producerRegistration.allGeners);
  const countriesList = allCountriesData?.map(country => country.countryName);
  const scriptTypeList = allScriptTypesData?.map(script=>script.scriptTypeName)
  const [popUpState, setPopUpState] = useState({
    open: false,
    title: '',
    text: '',
    negativeAction: null,
    normalAction: null,
    negativeActionText: '',
    normalActionText: '',
    popupType:'',
  });

  const handletog = (value) => {
    value && !dropdownState.dropdowns.selected.length > 0
      ? setIsGenreUnselected(true)
      : setIsGenreUnselected(false);
    setDropdownState((prev) => ({ ...prev, activeDropdown: !value }));
  };

      const gotoHome = (data) => {
        navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: activeHeader, toastValue : data }})
      }

// create cluster api call
const createCluster = (body) => {
    createClusterApi(body)
    .then((response) => {
      const { status } = response.data;
      if (["True", "OK"].includes(status)) {
        gotoHome({
          open: true,
          status: "success",
          title: Globals.ADD_NEW_CLUSTER.SUCCESS_TOAST,
        });
      } else {
        openPopUp(status === "False" ? "error" : "failed");
      }
    })
    .catch((error) => {
      console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
      openPopUp("failed");
    })
};


//update cluster api call
const updateCluster = (body) => {
  updateClusterApi(body, formValues.clusterId)
    .then((response) => {
      const { status } = response.data;
      if (status === "OK") {
        gotoHome({
          open: true,
          status: 'success',
          title: `${Globals.UPDATE_CLUSTER.SUCCESS_TOAST1}${name}${Globals.UPDATE_CLUSTER.SUCCESS_TOAST2}`
        });
      } else {
        openPopUp('failed');
      }
    })
    .catch((error) => {
      console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
      openPopUp('failed');
    });
};

  const openPopUp = (popUpType) => {
    const requestBody = {
      clusterName: name,
      countryId: country?.countryId,
      scriptTypeId: selectedScriptType?.scriptTypeId,
      approvalScore: Number(score),
      genreId: dropdownState.dropdowns.selected,
    };
    switch (popUpType) {
      case "abort":
        setPopUpState({
          open: true,
          title: Globals[addEditCluster].ABORT_POPUP_TITLE,
          text: Globals[addEditCluster].ABORT_POPUP_MESSAGE,
          negativeAction: gotoHome,
          negativeActionText: Globals[addEditCluster].ABORT_BUTTON_TEXT,
        });
        break;
      case "submit":
        setPopUpState({
          open: true,
          title: Globals[addEditCluster].TITLE,
          text: Globals[addEditCluster].POPUP_MESSAGE,
          normalAction: ()=>{update ? updateCluster(requestBody) : createCluster(requestBody)},
          normalActionText: Globals[addEditCluster].FOOTER_BTN_TITLE,
        });
        break;
      case "error":
        setPopUpState({
          open: true,
          title: Globals.ADD_NEW_CLUSTER.FAILURE_POPUP_TITLE,
          text: Globals.ADD_NEW_CLUSTER.ERROR_POPUP_MESSAGE1 + name + Globals.ADD_NEW_CLUSTER.ERROR_POPUP_MESSAGE2,
          popupType:popUpType,
          isDisabled:true,
        });
        break;
        default:
        setPopUpState({
          open: true,
          title: Globals[addEditCluster].FAILURE_POPUP_TITLE,
          text: Globals[addEditCluster].FAILURE_POPUP_MESSAGE,
          normalAction: ()=>{update ? updateCluster(requestBody) : createCluster(requestBody)},
          normalActionText: Globals[addEditCluster].FAILURE_BUTTON_TEXT,
          popupType:popUpType,
        });
        break;
    }
  };

  const handleCountryDropdown = (value) =>{
    if(value === Globals.ADD_NEW_CLUSTER.COUNTRY_PLACEHOLDER){
      setIsCountryInvalid(true)
    }else{
      country?.countryName !== value && setName('')
      setIsCountryInvalid(false)
      setCountry(allCountriesData.find(country=>country.countryName === value));
    }
  }

  const handleScriptDropdown = (value) =>{
    if(value === Globals.ADD_NEW_CLUSTER.SCRIPTED_PLACEHOLDER){
      setIsScriptInvalid(true)
    }else{
      selectedScriptType?.scriptTypeName !== value && setName('')
      setIsScriptInvalid(false)
      setSelectedScriptType(allScriptTypesData.find(script=>script.scriptTypeName === value));
    }
  }

  const handleClickOutside = (event) => {
    // Check if the click is outside all dropdowns
    const isClickInsideDropdown = Object.values(dropdownRefs.current).some(
      (ref) => ref?.contains(event.target)
    );
    if (!isClickInsideDropdown) {
      handletog(dropdownState.activeDropdown);
    }
  };

  const handleSelectAll = (selectAll, options) => {
    const selectedDataSting = options.map((option) => String(option.id));
    const selectedDataText = options.map((option) => String(option.name));
    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        selected: selectAll ? selectedDataSting : [],
        selectedText: selectAll ? selectedDataText : [],
      },
    }));
  };

  const handleSelect = (value) => {
    setDropdownState((prev) => {
      const dropdown = prev.dropdowns;
      if (!dropdown) return prev;
      const isSelected = dropdown.selected.includes(String(value.id));
      const inSelectedText = dropdown.selectedText.includes(String(value.name));
      const newSelected = isSelected
        ? dropdown.selected.filter((item) => item !== String(value.id)).map(String)
        : [...dropdown.selected.filter((item) => item !== String(value.id)), String(value.id)];

      const newSelectedText = inSelectedText
        ? dropdown.selectedText.filter((item) => item !== String(value.name)).map(String)
        : [
            ...dropdown.selectedText.filter((item) => item !== String(value.name)),
            String(value.name),
          ];
      return {
        ...prev,
        dropdowns: {
            selected: newSelected,
            selectedText: newSelectedText,
        },
      };
    });
  }

//country,script,genre api calls
  useEffect(() => {
    if (allCountriesData?.length === 0) {
      fetchAllCountries()
        .then((response) => {
          dispatch(setAllCountries({ allCountries: response.data.content }));
        })
        .catch((error) => {
          console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
        });
    }
    if (allScriptTypesData?.length === 0) {
      fetchAllScriptTypes()
        .then((response) => {
          dispatch(setAllScriptTypes({ allScriptTypes: response.data.content }));
        })
        .catch((error) => {
          console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
        });
    }
    if (allGenersData || allGenersData.length === 0) {
      fetchByfilter(OldGlobals.FILTER_OPTIONS_NAME.GENRE).then((response) => {
          dispatch(setAllGeners({ allGeners: response.data.content[OldGlobals.FILTER_OPTIONS_NAME.GENRE] }));})}
  }, []);

  useEffect(() => {
    if(dropdownState.activeDropdown){
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
    }, [dropdownState]);

// to update data initially in update cluster
  useEffect(() => {
    if (formValues && Object.keys(formValues).length) {
      setCountry(
        allCountriesData.find(
          (country) => country.countryName === formValues.country
        )
      );
      setSelectedScriptType(
        allScriptTypesData.find(
          (script) => script.scriptTypeName === formValues.scriptedNonScripted
        )
      );

      const genredata = allGenersData.reduce(
        (acc, genre) => {
          if (formValues.genre.includes(genre.name)) {
            acc.selected.push(String(genre.id));
            acc.selectedText.push(String(genre.name));
          }
          return acc;
        },
        { selected: [], selectedText: [] }
      );

      setDropdownState(prev => ({
        ...prev,
        dropdowns: genredata,
      }));
    }
  }, [allCountriesData?.length, allScriptTypesData?.length, allGenersData?.length]);

// setting cluster name depends on country and script
  useEffect(() => {
    if (country?.countryName && selectedScriptType?.scriptTypeName && !name) {
      setName(
        `${country.countryName + " " + selectedScriptType.scriptTypeName}`
      );
    }
  }, [country, selectedScriptType]);

    const handleScore = (event) => {
      setIsScoreInvalid(false);
      const ScoreValue = event.target.value;
      const isValid = validatescore(ScoreValue, 10);
      if (isValid) {
        setScore(ScoreValue);
        setIsScoreInvalid(false);
      } else {
        setIsScoreInvalid(true);
      }
    };

    const isFormValid =
      String(score)?.trim() !=='' &&
      country && Object.keys(country).length > 0 &&
      selectedScriptType && Object.keys(selectedScriptType).length > 0 &&
      !isScoreInvalid &&
      dropdownState.dropdowns.selected.length > 0;
 
  return (
    <div className="add-cluster-container">
      <GenericHeader title={Globals[addEditCluster].TITLE} onClose={()=>openPopUp("abort")} />
      <div className="add-cluster-content">
        <div className="add-cluster-form">
          <div className="add-cluster-title">{Globals.ADD_NEW_CLUSTER.BASIC_INFO}</div>
          <div id="add-cluster-details-row-1" className="row1-add-cluster">
            <div className="add-cluster-name-holder">
              <label id="add-cluster-name-label" className="add-cluster-label">
                {Globals.ADD_NEW_CLUSTER.NAME_TITLE}
                <span id="mandatory" className="mandatory">
                  {Globals.MANDATORY_FIELD}
                </span>
              </label>
              <input
                type="text"
                id="proposal-title-input"
                className={`addcluster-input ${name.length ? 'active' : ''}`}
                placeholder={Globals.ADD_NEW_CLUSTER.NAME_PLACEHOLDER}
                value={name}
                required
                disabled
              ></input>
            </div>
          </div>

          <div id="add-cluster-details-row-2" className="row2-add-cluster">
            <div className="add-cluster-score-holder">
              <label id="add-cluster-score-label" className="add-cluster-label">
                {Globals.ADD_NEW_CLUSTER.SCORE_TITLE}
                <span id="mandatory" className="mandatory">
                  {Globals.MANDATORY_FIELD}
                </span>
              </label>
              <input
                type="text"
                id="proposal-title-input"
                className="addcluster-input"
                placeholder={Globals.ADD_NEW_CLUSTER.SCORE_PLACEHOLDER}
                value={score}
                onChange={handleScore}
                onBlur={handleScore}
                min="1"
                max="10"
                required
                tabIndex="1"
              ></input>
              {isScoreInvalid && <div><img id="addcluster-error" className="addcluster-error" src={Globals.IMG.ERROR} alt="score error" /><label className='invalidClusterCredential'>{Globals.ERROR_MESSAGES.CLUSTER_APPROVAL_SCORE}</label></div>}
            </div>
          </div>

          <div id="add-cluster-details-row-3" className="row3-add-cluster">
            <div className="add-cluster-score-holder">
              <label id="add-cluster-region-label" className="add-cluster-label">
                {Globals.ADD_NEW_CLUSTER.COUNTRY_TITLE}
                <span id="mandatory" className="mandatory">
                  {Globals.MANDATORY_FIELD}
                </span>
              </label>
              <DropdownList
                selectClass={"addclusterDropdownSize"}
                dropdowncontainerclass={"add-cluster-dropdown"}
                placeHolderValue={Globals.ADD_NEW_CLUSTER.COUNTRY_PLACEHOLDER}
                options={countriesList}
                onSelect={handleCountryDropdown}
                selectedItem={country?.countryName}
                onBlur={(value)=>handleCountryDropdown(value.target.innerText)}
                required
                tabIndex="19"
                disabled={update}
              />
               {isCountryInvalid && <div><img id="addcluster-error" className="addcluster-error" src={Globals.IMG.ERROR} alt="score error" /><label className='invalidClusterCredential'>{Globals.ERROR_MESSAGES.EMPTY_COUNTRY}</label></div>}
            </div>
            <div className="add-cluster-score-holder">
              <label id="add-cluster-sctipted-label" className="add-cluster-label">
                {Globals.ADD_NEW_CLUSTER.SCRIPTED_TITLE}
                <span id="mandatory" className="mandatory">
                  {Globals.MANDATORY_FIELD}
                </span>
              </label>
              <DropdownList
                selectClass={"addclusterDropdownSize"}
                dropdowncontainerclass={"add-cluster-dropdown"}
                placeHolderValue={Globals.ADD_NEW_CLUSTER.SCRIPTED_PLACEHOLDER}
                options={scriptTypeList}
                onSelect={handleScriptDropdown}
                selectedItem={selectedScriptType?.scriptTypeName}
                onBlur={(value)=>handleScriptDropdown(value.target.innerText)}
                required
                tabIndex="19"
                disabled={update}
              />
               {isScriptInvalid && <div><img id="addcluster-error" className="addcluster-error" src={Globals.IMG.ERROR} alt="score error" /><label className='invalidClusterCredential'>{Globals.ERROR_MESSAGES.EMPTY_SCRIPT_TYPE}</label></div>}
            </div>
            <div className="add-cluster-score-holder">
              <label id="add-cluster-genre-label" className="add-cluster-label">
                {Globals.ADD_NEW_CLUSTER.GENRE_TITLE}
                <span id="mandatory" className="mandatory">
                  {Globals.MANDATORY_FIELD}
                </span>
              </label>
              <CheckboxDropDown
                      isOpen={dropdownState.activeDropdown}
                      options={allGenersData}
                      onToggle={() => handletog(dropdownState.activeDropdown)}
                      onSelectAll={(selectAll, options) =>
                        handleSelectAll(selectAll, options)
                      }
                      onSelect={handleSelect}
                      selectedValues={dropdownState.dropdowns.selected}
                      title={Globals.ADD_NEW_CLUSTER.GENRE_PLACEHOLDER}
                      selectedItems={dropdownState.dropdowns.selectedText}
                      className={"add-cluster-dropdown"}
                      outerDivClassName={`${dropdownState.dropdowns.selected.length ? 'active' : ''} addclusterDropdownSize`}
                      longInputText = {true}
                      dropdownRef={(el) => (dropdownRefs.current[Globals.ADD_NEW_CLUSTER.GENRE_TITLE] = el)}
                      fontColor={"selected-genre"}
                    />
                    {isGenreUnselected && <div><img id="addcluster-error" className="addcluster-error" src={Globals.IMG.ERROR} alt="score error" /><label className='invalidClusterCredential'>{Globals.ERROR_MESSAGES.EMPTY_GENRE}</label></div>}
            </div>
          </div>
        </div>
      </div>
      <div className="add-cluster-footer">
        <div className="add-cluster-footer-heading">
          <div className="add-cluster-footer-btn-group">
            <span className="cancel-add-cluster-btn" onClick={()=>openPopUp("abort")}>{Globals.HALF_PAGE_BRIEF_DETAILS.CANCEL}</span>
              <button onClick={()=>openPopUp("submit")} id="addcluster-submit-btn" className={`AddCluster-btn`} disabled = {!isFormValid}>{ Globals[addEditCluster].FOOTER_BTN_TITLE}</button>
          </div>
        </div>
      </div>
      {popUpState?.open && <PopUp
                    onClose={() => setPopUpState({open: false})}
                    text={popUpState.text || ''}
                    title={popUpState.title || ''}
                    negativeAction={popUpState.negativeAction}
                    normalAction={popUpState.normalAction}
                    negativeActionText={popUpState.negativeActionText}
                    normalActionText={popUpState.normalActionText}
                    popupType={popUpState.popupType}
                    disable={popUpState.isDisabled}
                />}
    </div>
  );
};

export default AddCluster;
